// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1DeBzahDYQ-TMMS44fs0v1","buttonDiv":"_2etsKI5_smo5kM4X9smbQw","input":"_3Wr4mK5tnV4Fk3aHMw7Y0w","svg":"_2jiZDvONh6ECyEKiCe1RQK","alert":"P1fCVDNOJ7Dquoy6kn0pY"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Header/Form/styles.scss
 ** module id = 425
 ** module chunks = 0
 **/